module.exports = __webpack_public_path__ + "static/media/trex.87b21101.gif";